<template lang="pug">
  .user-details
    v-row
      v-col(sm="6")
        h2.primary--text Mein Profil

      v-col.text-right(v-if="isEdited" sm="6")
        v-btn.mr-2(color="primary" @click="loadUserDetails") Rückgängig
        v-btn(color="primary" @click="onSaveUser") Speichern

    v-dialog(v-model="showPasswordModal" width="450")
      password-form.mt-0(
        :user-id="userId"
        @saved="showPasswordModal = false"
      )

    v-form(ref="form-user" lazy-validation @submit.prevent="() => {}")
      v-row.my-6
        v-col.pb-0(cols="12" sm="6"): v-text-field(
          v-model="userId"
          label="ID"
          type="number"
          outlined
          readonly
        )

        v-col.pb-0(cols="12" sm="6")

        v-col.pb-0(cols="12" sm="6"): v-text-field(
          v-model="user.forename"
          label="Vorname"
          outlined
          :rules="[ rules.required ]"
        )

        v-col.pb-0(cols="12" sm="6"): v-text-field(
          v-model="user.lastname"
          label="Nachname"
          outlined
          :rules="[ rules.required ]"
        )

        v-col.pb-0(cols="12" sm="6"): v-text-field(
          v-model="user.email"
          label="E-Mail"
          outlined
          :rules="[ rules.email, rules.required ]"
        )

        v-col.pb-0(cols="12" sm="6"): v-text-field(
          v-model="user.mobile_nr"
          label="Mobil-Nr."
          outlined
        )

        v-col.pb-0(cols="12"): v-textarea(
          v-model="user.contact_data"
          label="Standard-Text Absender (Druckansicht)"
          outlined
        )

        v-col.pb-0(v-if="!isSSO" cols="12" sm="6"): v-checkbox.mt-0(
          v-model="user.disabled"
          label="Deaktiviert"
          hide-details
          disabled
        )

        v-col.pb-0(v-if="!isSSO && user.has_password" cols="12" sm="6"): v-checkbox.mt-0(
          v-model="user.email_validated"
          label="Email validiert"
          hide-details
          disabled
        )

        v-col.pb-0.mt-4(v-if="!isSSO && user.has_password" cols="12")
          v-btn(color="primary" @click="showPasswordModal = true") Passwort ändern

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    PasswordForm: () => import('@/pages/auth/password')
  },

  computed: mapGetters([
    'userData',
  ]),

  watch: {
    user: {
      deep: true,
      handler () {
        this.isEdited = true
      }
    }
  }
})
export default class Profile extends Vue {
  user = {}
  showPasswordModal = false
  isEdited = false

  get userId () {
    if (!this.userData || !this.userData.user_id) {
      return 0
    }

    return this.userData.user_id
  }

  mounted () {
    this.loadUserDetails()
  }

  loadUserDetails () {
    if (!this.userId) {
      return
    }

    this.$axios
      .get(Urls.User(this.userId))
      .then(res => {
        this.user = res.data
        this.$nextTick(() => {
          this.isEdited = false
        })
      })
  }

  onSaveUser () {
    if (!this.isFormValid('form-user')) {
      return
    }

    const params = {
      forename: this.user.forename,
      lastname: this.user.lastname,
      email: this.user.email,
      mobile_nr: this.user.mobile_nr,
      contact_data: this.user.contact_data,
    }

    this.$axios
      .put(Urls.User(), params)
      .then(() => {
        this.$toast.success('Daten gespeichert', 'Speichern')
        this.isEdited = false
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
  }
}
</script>
